import { Navigate } from "react-router-dom";
import { useAuth } from "../../lib/auth/AuthProvider";

export function Logout() {
    const auth = useAuth();
    auth.logout();
    return <Navigate to="/login" />;
}
